// import '../App.css';
import FloatingButton from '../components/FloatingButtonMui';


function Home(props) {
  return (
    <div >
      
      <FloatingButton 
        pageLink="/tcm-page"
        company_name="Mon plombier" 
        // TCM_API_KEY="jamso20389732AI-AD" 
        TCM_API_KEY="tcmGnwutCElj2hTmKfVd53kkyiY6irJZfaQ6S3dbiv6ik3RHxvoBvYTQehuRzIlv" 
        message="This is a floating message!" 
        // headerColor="#00029F" 
        sendButtonColor="#0ff006" 
        height="680px"
        width="400px"
        goToMessagePage={()=> {}}/>

    </div>
  );
}

export default Home
